module.exports = __webpack_public_path__ + "img/dementia-04-risk-factor.91166ae4.jpg";